import React from "react";
import ResponseMessages from "web-common-ssr/src/views/components/ResponseMessages/ResponseMessages";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo,
    });
  }

  render() {
    if (this.state.errorInfo || this.state.hasError) {
      return (
        <>
          <ResponseMessages
            messageType="error"
            message={this.state.error?.toString() || "Something went wrong"}
          />
        </>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
